module.exports = __webpack_public_path__ + "media/images/social/social-icon-ya-d4295025a698edba143fdafd300797d6.svg";